"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        height: '100%',
        display: 'flex',
        paddingLeft: constants_1.ATC_X_PADDING,
        paddingRight: constants_1.ATC_X_PADDING
    }
};
//# sourceMappingURL=atc.style.js.map